import { action, makeObservable, observable } from 'mobx'
import { between } from 'utils/validation-utils'
import { validationContext, required } from 'validx'
import {
  IInventoryItemPricingEditor,
  InventoryItemMarkupValues,
  InventoryItemPricingValues,
} from './inventory-item-pricing-editor'
import { InventoryItemPricing } from 'admin/inventory/InventoryItem'

/**
 * View Model for Inventory Items of type Markup.
 */
export class MarkupEditorViewModel implements IInventoryItemPricingEditor {
  /**
   * The rate by which the job's price will be marked up.
   */
  clientMarkupRate = 0

  /**
   * The rate by which the pro's payout will be marked up.
   */
  proPayoutMarkupRate = 0

  /**
   * Validation context.
   */
  validation = validationContext(this, {
    clientMarkupRate: [
      required('A client markup rate is required.'),
      between(0, 100, 'The rate must be between 0 and 100.'),
    ],

    proPayoutMarkupRate: [
      required('A pro payout markup rate is required.'),
      between(0, 100, 'The rate must be between 0 and 100.'),
    ],
  })

  constructor() {
    makeObservable(this, {
      clientMarkupRate: observable,
      proPayoutMarkupRate: observable,
      hydrate: action.bound,
      reset: action.bound,
    })
  }

  /**
   * @inheritdoc
   */
  validate(): boolean {
    return this.validation.reset().validate().isValid
  }

  /**
   * @inheritdoc
   */
  hydrate(values: InventoryItemMarkupValues): void {
    this.clientMarkupRate = values.clientMarkupRate
    this.proPayoutMarkupRate = values.proPayoutMarkupRate
  }

  /**
   * @inheritdoc
   */
  toValues(): InventoryItemPricingValues {
    return {
      type: InventoryItemPricing.Markup,
      clientMarkupRate: this.clientMarkupRate,
      proPayoutMarkupRate: this.proPayoutMarkupRate,
    }
  }

  /**
   * @inheritdoc
   */
  reset() {
    this.clientMarkupRate = 0
    this.proPayoutMarkupRate = 0
    this.validation.reset()
  }
}
